import slugify from "slugify"
import nl2br from 'nl2br'
import Vue from 'vue'

export default {

	computed: {

		$loggedin: function() {

			return this.$store.getters['key']

		},

		$context: function() {

			return this.$store.getters['context']

		},

		$canDelete: function() {

			var user = this.$store.getters['user']

			return user.level === 1 || (user.access && user.access.level <= 2)

		}

	},

	methods: {

		$permission: function(types, level) {

			if(level === undefined) {

				level = types
				types = this.$route.meta.permission

			}

			types = (this.$_.isArray(types)) ? types : [types]

			var user = this.$store.getters['user']

			var requiredLevel = 1

			if (level === 'read') requiredLevel = 1
			if (level === 'edit') requiredLevel = 2
			if (level === 'full') requiredLevel = 3

			if (user.level === 1) return true

			if(!user.access) return false

			return this.$_.filter(types, function(type) {

				return user.access.permissions[type] >= requiredLevel

			}).length

		},

		$vueset: function(object, name, value) {

			Vue.set(object, name, value)

		},

		$nl2br: function(text) {

			return nl2br(text)

		},

		$log: function(e) {

			console.log(e)

		},

		$highlight: function(text, match) {

			if (!match || match === true) return text

			var altText = slugify(text, {
				replacement: ' ',
				lower: true
			})
	
			match = slugify(match, {
				replacement: ' ',
				lower: true
			})

			var pos = altText.indexOf(match)
			var len = match.length

			return text.slice(0, pos) + '<b>' + text.slice(pos, pos + len) + '</b>' + text.slice(pos + len)

		}

	}

}